<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-help</v-icon>
        <v-toolbar-title>Statement Line Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="stmtLnType"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
              v-model="selected"
            >
              <template v-slot:item="row"
                ><tr>
                  <td style="width: 50px">
                    <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.stmtLnType)"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.stmtLnType }}</td>
                  <td class="text-xs-left">{{ row.item.stmtLnTypeDesc }}</td>
                  <!-- <td class="text-xs-center" >
                  <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td> -->
                </tr>
              </template>
            </v-data-table>
            <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
            <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'insured')">
              Select All
              <v-icon right>mdi-check-all</v-icon>
            </v-btn>
            <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
              Reset
              <v-icon dark right>mdi-refresh</v-icon></v-btn
            >
            <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'insured')">
              Select
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI } from '@/utils/ajax'
import { helpListMixin } from '@/mixins/common/helpListMixin'

export default {
  data() {
    return {
      stmtLnType: 'stmtLnType',
      headers: [
        { text: '', align: 'center', value: 'stmtLnType' },
        { text: 'Statement Line Type', value: 'stmtLnType' },
        { text: 'Statement Line Type Description', value: 'stmtLnTypeDesc' }
      ],
      labels: {
        stmtLnType: 'Statement Line Type',
        stmtLnTypeDesc: 'Statement Line Type Description'
      },
      filters: {
        stmtLnType: undefined,
        stmtLnTypeDesc: undefined
      },
      loading: false,
      selectedStmtLnType: undefined,
      parameter: [],
      selected: [],
      items: [],
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  props: {
    mode: String,
    param: String
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    },
    param: function (value) {
      this.doInit()
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      if (this.param !== undefined) {
        if (this.param.includes(',')) {
        }
        this.parameter = this.param.split(',')
      }
      const apiURI = this.menu.getStmtLnTypeListByDrCrTypeNotM
      if (apiURI) {
        this.loading = true
        if (this.parameter !== this.checkedItems) {
          // CBO: to reset the 'this.checkedItems' if called from different mode
          this.doReset()
          this.checkedItems = this.parameter
        }
        try {
          this.loading = true
          let expand = {
            stmtLnType: this.stmtLnType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((stmtLnType) => {
                const convertList = {
                  stmtLnType: stmtLnType.stmtLnType,
                  stmtLnTypeDesc: stmtLnType.stmtLnTypeDesc
                }
                if (this.checkedItems.includes(stmtLnType.stmtLnType)) {
                  const paramList = {
                    stmtLnType: stmtLnType.stmtLnType,
                    stmtLnTypeDesc: stmtLnType.stmtLnTypeDesc
                  }
                  this.selectedItems.push(paramList)
                }
                this.items.push(convertList)
              })
            }
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
    // doSelect(data) {
    //   console.log(data)
    //   const stmtLnTypeObj = {
    //     stmtLnType: data.stmtLnType,
    //     stmtLnTypeDesc: data.stmtLnTypeDesc
    //   }
    //   this.$emit('selectStmtLnType', stmtLnTypeObj)
    //   this.$emit('close')
    // }
  },
  computed: {
    menu() {
      return this.$store.state.stmtType.menu
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin, helpListMixin]
}
</script>

<style>
</style>
